import { render, staticRenderFns } from "./OverviewTargetBranch.vue?vue&type=template&id=2b2626bc"
import script from "./OverviewTargetBranch.vue?vue&type=script&lang=js"
export * from "./OverviewTargetBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports